// =============================================================================
// web/shims/react-native-keychain.js — WEB shim for react-native-keychain.
//
// The native lib is a hardware-backed (iOS Keychain / Android Keystore)
// credential store. On the WEB target there is no such secure enclave, so this
// shim backs the SAME generic-password API with localStorage. It is only wired
// on web (via webpack alias in webpack.config.js) — native iOS resolves the real
// module untouched.
//
// Contract preserved for services/secure-store.ts:
//   getGenericPassword({service})            → { username, password } | false
//   setGenericPassword(username, password, {service})
//   resetGenericPassword({service})
// =============================================================================
const PREFIX = 'cryb.keychain.';

function keyFor(options) {
  const service = (options && options.service) || 'default';
  return PREFIX + service;
}

function safeStorage() {
  try {
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
  } catch {}
  return null;
}

export async function getGenericPassword(options) {
  const ls = safeStorage();
  if (!ls) return false;
  try {
    const raw = ls.getItem(keyFor(options));
    if (raw == null) return false;
    const parsed = JSON.parse(raw);
    return { username: parsed.username || 'cryb', password: parsed.password };
  } catch {
    return false;
  }
}

export async function setGenericPassword(username, password, options) {
  const ls = safeStorage();
  if (!ls) return false;
  try {
    ls.setItem(keyFor(options), JSON.stringify({ username, password }));
    return true;
  } catch {
    return false;
  }
}

export async function resetGenericPassword(options) {
  const ls = safeStorage();
  if (!ls) return true;
  try {
    ls.removeItem(keyFor(options));
    return true;
  } catch {
    return true;
  }
}

export default {
  getGenericPassword,
  setGenericPassword,
  resetGenericPassword,
};
